import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser } from './helpers/user';

const NivelDeAcessoGuard = ({ children, niveisPermitidos }) => {
  const user = getUser();

  const userNivel = user?.usuario?.nivel || 0;

  const temPermissao = niveisPermitidos.includes(userNivel);

  if (!temPermissao) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return children;
};

export default NivelDeAcessoGuard;